import React, { useEffect, useState } from "react";
import TitleBarComponent from "../../../components/titlebar/TitleBarComponent";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Select,
  Spin,
  Switch,
  Table,
  TableProps,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../lib/hook";
import { ITrip } from "../../../lib/features/trips/trips.constant";
import { onGetListTrip } from "../../../lib/features/trips/trips.thunk";
import ButtonAddTrip from "./button/ButtonAddTrip";
import { formatLocalDate } from "../../../function/date";
import { removeVietnameseTones } from "../../../function/removeVietnameaseTones";
import dayjs from "dayjs";
import { listStatusTrip } from "../../../constant/listStatusTrip";
import { convertLunaDate } from "../../../function/convertLunaDate";
interface TripsPageProps {
  // Add props here
}

const TripsPage: React.FC<TripsPageProps> = () => {
  const navigate = useNavigate();
  const { isGot, trips, dateFrom, status } = useAppSelector(
    (store) => store?.trips
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [filteredTrips, setFilteredTrips] = useState<ITrip[]>([]);
  const [isLuna, setIsLuna] = useState<boolean>(true);
  const today = dayjs();

  const dispatch = useAppDispatch();
  const handleGetListTrip = async (dateFrom: string, status: string | null) => {
    setLoading(true);
    await dispatch(onGetListTrip({ dateFrom: dateFrom, status: status }));
    setLoading(false);
  };

  useEffect(() => {
    if (!isGot) {
      handleGetListTrip(today?.toISOString(), "active");
    }
  }, []);
  useEffect(() => {
    setFilteredTrips(trips);
  }, [trips]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);

    const keyword = removeVietnameseTones(value.toLowerCase());

    if (!keyword) {
      setFilteredTrips(trips); // nếu trống thì hiển thị full
      return;
    }

    const filtered = trips.filter((trip) => {
      const fullName = removeVietnameseTones(
        trip.nameNoAccent?.toLowerCase() || ""
      );

      return fullName.includes(keyword);
    });

    setFilteredTrips(filtered);
  };
  function groupTripsByMonth(trips: ITrip[], isLuna: boolean) {
    const grouped: Record<string, ITrip[]> = {};

    // 1. Sort timeline theo ngày DƯƠNG lịch thực tế
    const sortedTrips = [...trips].sort(
      (a, b) =>
        new Date(a.departureDate).getTime() -
        new Date(b.departureDate).getTime()
    );

    // 2. Group theo Âm hoặc Dương nhưng KHÔNG ảnh hưởng sort timeline
    sortedTrips.forEach((trip) => {
      const date = new Date(
        isLuna ? trip.departureLunaDate : trip.departureDate
      );

      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      const key = `${year}-${month.toString().padStart(2, "0")}`;

      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(trip);
    });

    return grouped;
  }

  const grouped = groupTripsByMonth(filteredTrips, isLuna);
  return (
    <div>
      <TitleBarComponent
        title="Chuyến đi"
        reload={() => handleGetListTrip(dateFrom, status)}
        actionButton={<ButtonAddTrip />}
      />
      <div className="flex flex-col gap-2 w-full mb-2">
        {/* Ô tìm kiếm */}
        <div className="w-full sm:flex sm:justify-end">
          <div className="w-full sm:w-[300px]">
            <Input
              placeholder="Tìm kiếm..."
              value={searchText}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        {/* Filter + Date */}
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-3 w-full">
          {/* Select trạng thái */}
          <Form.Item className="mb-0 w-full sm:w-auto">
            <Select
              value={status}
              className="w-full sm:w-[140px]"
              onChange={(value) => handleGetListTrip(dateFrom, value)}
              options={[
                { value: null, label: "Tất cả" },
                { value: "hidden", label: "Đã ẩn" },
                { value: "active", label: "Hoạt động" },
              ]}
            />
          </Form.Item>

          {/* Date + Switch */}
          <Form.Item className="mb-0 w-full sm:w-auto">
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <DatePicker
                className="w-full sm:w-[140px]"
                value={dayjs(dateFrom)}
                format="DD-MM-YYYY"
                onChange={(value) => {
                  if (value) handleGetListTrip(value.toISOString(), status);
                  else handleGetListTrip(today?.toISOString(), status);
                }}
              />
              <Switch
                checked={!isLuna}
                checkedChildren="Dương"
                unCheckedChildren="Âm"
                onChange={(value) => setIsLuna(!value)}
              />
            </div>
          </Form.Item>
        </div>
      </div>

      {loading ? (
        <div className="md:hidden flex flex-col gap-2 ">
          <Spin tip="Đang tải..."></Spin>
        </div>
      ) : (
        <div className="flex flex-col gap-2 ">
          {Object.entries(grouped).map(([month, tripList]) => {
            const [year, monthNum] = month.split("-");
            return (
              <div key={month}>
                <div className="flex justify-between items-center">
                  <h2
                    className={`text-xl font-bold mb-3 ${
                      isLuna ? "text-red-500" : "text-blue-600"
                    } `}
                  >
                    Tháng {monthNum} {isLuna ? "(Âm lịch" : "(Dương lịch"}{" "}
                    {year})
                  </h2>
                </div>

                <div className="grid grid-cols-1 gap-3 mb-1">
                  {tripList.map((trip, index) => (
                    <div
                      onClick={() => navigate(`${trip?._id}`)}
                      key={index}
                      className="p-2.5 rounded-xl bg-white flex flex-col gap-2  shadow-md active:scale-[0.97] active:bg-gray-100 w-full
                  transition-all duration-75"
                    >
                      <div className="w-full flex justify-between gap-2 items-center">
                        <div className="flex flex-col gap-1 w-full">
                          <p className="text-[22px] font-bold mb-1">
                            {trip?.name}
                          </p>
                          <div className="flex items-center gap-2 mt-0.5">
                            <div className="rounded-md py-[1px]  px-1.5 bg-gray-400 shadow-md  text-white h-fit w-fit flex justify-center items-center">
                              <p className="text-sm font-medium">
                                {trip?.numberOfDate}N-{trip?.numberOfNight}Đ
                              </p>
                            </div>
                            {!!trip?.isNightDeparture && (
                              <div className="rounded-md py-[1px]  px-1.5 bg-orange-600 shadow-md  text-white h-fit w-fit flex justify-center items-center">
                                <p className="text-sm font-medium">Đi đêm</p>
                              </div>
                            )}
                            {
                              listStatusTrip?.find(
                                (item) => item?.value === trip?.status
                              )?.tag
                            }
                          </div>
                        </div>

                        <div className="flex flex-col gap-1 items-end">
                          <div
                            className={`py-1 px-2 rounded-xl shadow-md bg-red-500`}
                          >
                            <span className="text-white font-bold text-lg">
                              {
                          convertLunaDate(
                            new Date(trip?.departureDate)
                          )?.lunar?.get()?.day
                        }
                        /
                        {
                          convertLunaDate(
                            new Date(trip?.departureDate)
                          )?.lunar?.get()?.month
                        }
                            </span>
                          </div>
                          <span className="text-blue-500 font-medium text-base">
                            {formatLocalDate(trip?.departureDate)}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TripsPage;
